import { AppNav } from '@/components/layout/AppNav'
import { FlashBanner } from '@/components/ui/FlashBanner'

interface AppLayoutProps {
  children: React.ReactNode
}

export function AppLayout({ children }: AppLayoutProps) {
  return (
    <div className="min-h-dvh bg-page-bg font-sans text-body transition-colors duration-500 flex flex-col">
      <AppNav />
      <main id="main-content" tabIndex={-1} className="flex-1 outline-none">
        {children}
      </main>
      <FlashBanner />
    </div>
  )
}
